import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import React, { useState } from "react";
import { Typography, Container, Grid } from "@mui/material";
import styles from "./style.module.scss";
import GirlBeach from "../../assets/gallery/Default_A_fit_girl_on_a_beach_playing_volleyball_with_friends_1.jpg"
import Jedi from "../../assets/gallery/Default_Jedi_Knight_in_a_lightsaber_duel_with_a_sith_lord_at_d_0.jpg"
import Bazar from "../../assets/gallery/wRHr4pMP5IqAUgsILeTXBES1.png"
import Lollipop from "../../assets/gallery/bcKI3PQKdBbjw7NRPlCgH35j.png"
import Bear from "../../assets/gallery/bear.png"
import Bike from "../../assets/gallery/bike.png"
import Happy from "../../assets/gallery/happy.png"
import Fight from "../../assets/gallery/ecoCEG4F8KsvVWBwvLqqvFUa.png"
import Batman from "../../assets/gallery/batman.png"
import Man from "@assets/gallery/j2WEkNZyrnTrCXUVFYefpnyT.png"
import Footballer from "@assets/gallery/footballer.png"
import Computer from "@assets/gallery/computer.png"
import Army from "@assets/gallery/army.png"
import Rain from "@assets/gallery/rain.png"
import Writer from "@assets/gallery/writer.png"
import motherDay from "@assets/gallery/motherDay.png"
import celebration from "@assets/gallery/celebration.png"
import detective from "@assets/gallery/detective.png"
import lollipop from "@assets/gallery/lollipop.png"
import knight from "@assets/gallery/knight.jpg"
import laptop from "@assets/gallery/laptop.png"
import coffee from "@assets/gallery/coffee.png"
import wizard from "@assets/gallery/wizard.png"
import artist from "@assets/gallery/artist.png"
import wolf from "@assets/gallery/wolf.png"
import forest from "@assets/gallery/forest.png"
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Spring from '@components/Spring';

function MasonryImageList() {
  return (

    <Box className={styles.masonry} sx={{ maxHeight: 850, overflowY: 'scroll' }}>
      <ImageList variant="masonry" cols={5} gap={10}>
        {itemData.map((item) => (
          <ImageListItem key={item.img} style={{borderRadius:"10px"}}>
            <img
            style={{borderRadius:"10px"}}
              srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
              src={`${item.img}?w=248&fit=crop&auto=format`}
              alt={item.title}
              loading="lazy"
            />
          </ImageListItem>
        ))}
      </ImageList>
    </Box>
  );
}

const itemData = [
  {
    img:Happy ,
    title: 'Bed',
  },
  {
    img: Lollipop,
    title: 'Books',
  },
  {
    img: Jedi,
    title: 'Kitchen',
  },
  {
    img: Man,
    title: 'Blinds',
  },
  {
    img: Bike,
    title: 'Chairs',
  },
  {
    img: Bear,
    title: 'Laptop',
  },
  {
    img: GirlBeach,
    title: 'Doors',
  },
  {
    img: Footballer,
    title: 'Coffee',
  },
  {
    img: Bazar,
    title: 'Storage',
  },
  {
    img: Fight,
    title: 'Candle',
  },
  {
    img: Writer,
    title: 'Coffee table',
  },
  {
    img: detective,
    title: 'Coffee',
  },
  {
    img: Rain,
    title: 'Candle',
  },
  {
    img: Army,
    title: 'Coffee table',
  },
  {
    img: lollipop,
    title: 'Coffee table',
  },
  {
    img: knight,
    title: 'Coffee table',
  },
  {
    img: laptop,
    title: 'Coffee table',
  },
  {
    img: coffee,
    title: 'Coffee table',
  },
  {
    img: wizard,
    title: 'Coffee table',
  },
  {
    img: artist,
    title: 'Coffee table',
  },
  {
    img: wolf,
    title: 'Coffee table',
  },
  {
    img: forest,
    title: 'Coffee table',
  },

];


const Gallery = () => {
  return (
    <>
      <section className="hero">
      <Container>
      <div style={{display:"flex",textAlign:"center",justifyContent:"center"}}>
            <Typography variant="h2" gutterBottom className={styles.feature_heading}>
              Photo Gallery
            </Typography>
          </div>
        <div className="hero-content">

        <Spring>
        <Container className={styles.text_container}>
          <MasonryImageList />

          </Container>
        </Spring>
        </div>
      </Container>
      </section>
    </>
  );
};

export default Gallery;
